module.exports = __webpack_public_path__ + "img/image-xls.6dda4582.png";